<template>
  <section class="accruals-estimation-method" data-testid="accruals-configuration-page__estimation-method">
    <header class="accruals-estimation-method__header">
      <div class="accruals-estimation-method__heading">
        <h2 class="accruals-estimation-method__title">How to Estimate</h2>
        <p class="accruals-estimation-method__subtitle">Estimation method and calculation</p>
      </div>
    </header>

    <div class="accruals-estimation-method__card">
      <div class="accruals-estimation-method__methods">
        <button
          v-for="method in methods"
          :key="method.id"
          type="button"
          class="accruals-estimation-method__method-card"
          :class="{ 'accruals-estimation-method__method-card--selected': method.id === selectedMethodId }"
          :data-testid="`accruals-configuration-page__method-card--${method.id}`"
          @click="onSelectMethod(method.id)"
        >
          <div class="accruals-estimation-method__method-top">
            <span class="accruals-estimation-method__method-code">{{ method.code }}</span>
            <span
              v-if="method.id === selectedMethodId"
              class="accruals-estimation-method__method-check"
              aria-hidden="true"
            >
              <img :src="assets.ICON_METHOD_CHECK" alt="" />
            </span>
          </div>
          <div class="accruals-estimation-method__method-copy">
            <p class="accruals-estimation-method__method-title">{{ method.title }}</p>
            <p class="accruals-estimation-method__method-description">{{ method.description }}</p>
          </div>
        </button>
      </div>

      <div class="accruals-estimation-method__preview">
        <button
          type="button"
          class="accruals-estimation-method__preview-trigger"
          data-testid="accruals-configuration-page__method-preview-toggle"
          @click="previewExpanded = !previewExpanded"
        >
          <span>WHAT THIS RULE WILL CALCULATE</span>
          <img
            :src="assets.ICON_CHEVRON_DOWN"
            alt=""
            class="accruals-estimation-method__preview-chevron"
            :class="{ 'accruals-estimation-method__preview-chevron--expanded': previewExpanded }"
          />
        </button>
        <div
          v-if="previewExpanded"
          class="accruals-estimation-method__preview-body"
          data-testid="accruals-configuration-page__method-preview-body"
        >
          <p
            v-for="(line, index) in previewLines"
            :key="`preview-${index}`"
            class="accruals-estimation-method__preview-line"
          >
            {{ line }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ACCRUALS_CONFIG_ASSETS } from '../accrualsConfigurationConstants';
import {
  ESTIMATION_METHOD_DEFINITIONS,
  catalogTemplatesToMethods,
  getEstimationMethodsForApplyOn,
  getMethodPreviewLines,
} from '../accrualsEstimationRulesConstants';

export default {
  name: 'AccrualsEstimationMethodSection',
  props: {
    applyOn: { type: String, default: 'vendor' },
    selectedMethodId: { type: String, default: '' },
    methodConfig: { type: Object, default: () => ({}) },
    templates: { type: Array, default: () => [] },
  },
  data() {
    return {
      assets: ACCRUALS_CONFIG_ASSETS,
      previewExpanded: true,
    };
  },
  computed: {
    catalogMethods() {
      return catalogTemplatesToMethods(this.templates, this.applyOn);
    },
    methods() {
      const fromCatalog = this.catalogMethods;
      const base = fromCatalog.length
        ? fromCatalog
        : getEstimationMethodsForApplyOn(this.applyOn);
      if (this.selectedMethodId && !base.some((method) => method.id === this.selectedMethodId)) {
        const extra = ESTIMATION_METHOD_DEFINITIONS[this.selectedMethodId];
        if (extra) return [...base, extra];
      }
      return base;
    },
    selectedDefinition() {
      return this.methods.find((method) => method.id === this.selectedMethodId)
        || ESTIMATION_METHOD_DEFINITIONS[this.selectedMethodId]
        || null;
    },
    previewLines() {
      return getMethodPreviewLines(this.selectedMethodId, this.methodConfig, this.selectedDefinition);
    },
  },
  methods: {
    onSelectMethod(methodId) {
      if (methodId === this.selectedMethodId) return;
      const definition = this.methods.find((method) => method.id === methodId)
        || ESTIMATION_METHOD_DEFINITIONS[methodId];
      this.$emit('select-method', {
        methodId,
        methodConfig: {},
        badge: definition?.badge || definition?.code || '',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsEstimationMethodSection.scss';
</style>
